<script>
import {mapGetters, mapActions} from 'vuex'
import VideoModal from '@/components/modals/VideoModal.vue'
import userActions from '@/mixins/actionsMixin'
export default {
	mixins: [userActions],
	components: {
		VideoModal
	},

	data() {
		return {
			modal: '',
			activity: ''
		}
	},

	computed: {
		
		...mapGetters({
			activityById: 'activities/byId',
		})
	},

	watch: {
		'$route.params': {
			handler(nVal) {
				debugger
				try {
					this.modal = nVal.modal || null
					this.activity = Number(nVal.activity)|| null
					this.showModal()
				} catch (error) {
					
				}
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		showModal() {
			const vm = this
			if(!vm.modal) return
			vm.$refs[vm.modal].show()
		},
		// handlerSaveTimeUserBack() {
		// 	this.saveTimeUserBack()
		// 	this.$el.removeEventListener('click', this.handlerSaveTimeUserBack)
		// },
	},

	mounted() {
		this.showModal()
		this.saveTimeUserBack()
	},
}
</script>
<template>
	<div class="">
		<img class="logo-menu" src="@/assets/img/logo_blanco.png" alt="">
		<h3 class="title-menu">Menú de navegación</h3>
		<VideoModal ref="video" :activity="activityById(activity) || {}"/>
	</div>
</template>